// import dynamic from 'next/dynamic';
// import ScrollToTop from '../componets/scroll';
// import GoogleTranslate from '../componets/GoogleTranslate'; // Import the Google Translate component
// import { useEffect } from 'react';

// // If Header has a default export
// const Header = dynamic(() => import('../componets/header'), { ssr: false });

// // If Footer is a named export
// const Footer = dynamic(() => import('../componets/footer').then(mod => mod.Footer), { ssr: false });

// export default function Layout({ children }) {

//     useEffect(() => {
//     if ("scrollRestoration" in window.history) {
//       window.history.scrollRestoration = "manual";
//     }
//   }, []);
//   return (
//     <>
//       <Header />
//       {/* <GoogleTranslate /> */}
//       <main className=" ">
//         {children}
//       </main>
//       <ScrollToTop />
//       <Footer />
//     </>
//   );
// }


import dynamic from 'next/dynamic';
import ScrollToTop from '../componets/scroll';
import GoogleTranslate from '../componets/GoogleTranslate';
import { useEffect, useState } from 'react';
import ResetPasswordPopup from '../componets/ResetPasswordPopup'; // 🔹 Import the popup

// If Header has a default export
const Header = dynamic(() => import('../componets/header'), { ssr: false });

// If Footer is a named export
const Footer = dynamic(() => import('../componets/footer').then(mod => mod.Footer), { ssr: false });

export default function Layout({ children }) {
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [reset, setReset] = useState(false);

  useEffect(() => {
    // Scroll restoration
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // 🔹 Detect reset link
    const params = new URLSearchParams(window.location.search);
    const reset = params.get("reset");
    const email = params.get("email");

    if (email) {
      setResetEmail(email);
      setReset(reset)
      setShowResetPopup(true);
    }
  }, []);

  return (
    <>
      <Header />
      {/* <GoogleTranslate /> */}
      <main className="">
        {children}
      </main>
      <ScrollToTop />
      <Footer />

      {/* 🔹 Reset Password Popup */}
      {showResetPopup && (
        <ResetPasswordPopup
          email={resetEmail}
          onClose={() => setShowResetPopup(false)}
          reset={reset}
        />
      )}
    </>
  );
}

